import { render, staticRenderFns } from "./AddOrUpdateAssemblyForm.vue?vue&type=template&id=4d678f51"
import script from "./AddOrUpdateAssemblyForm.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateAssemblyForm.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateAssemblyForm.vue?vue&type=style&index=0&id=4d678f51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports